'use client';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useRecaptcha = (): {
  executeRecaptcha: (action: string) => Promise<string | null>;
  isLoaded: boolean;
} => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const executeRecaptchaAction = async (
    action: string
  ): Promise<string | null> => {
    if (!executeRecaptcha) {
      console.error('Execute recaptcha not yet available');
      return null;
    }

    try {
      const token = await executeRecaptcha(action);
      return token;
    } catch (error) {
      console.error('reCAPTCHA execution failed:', error);
      return null;
    }
  };

  return {
    executeRecaptcha: executeRecaptchaAction,
    isLoaded: !!executeRecaptcha,
  };
};
